import React, { createContext, useCallback, useEffect, useState } from 'react';

import { useJsApiLoader } from '@react-google-maps/api';
import Map from './Map';
import { LayerProp, LayersMenu, MAP_ROAD } from './LayersMenu';

export type GoogleMapsContextProps = {
  mapInstance?: google.maps.Map,
  Map?: JSX.Element,  
  trafficLayer?: google.maps.TrafficLayer
  transitLayer?: google.maps.TransitLayer
  layer?: LayerProp,
  setLayer?(layer:LayerProp): any
}

export const GoogleMapsContext = createContext<GoogleMapsContextProps>({})

type ProviderProps = {
  googleMapsApiKey: string
  zoom?: number,
  center?: google.maps.LatLngLiteral | google.maps.LatLng
  children?: JSX.Element
}

export const GoogleMapsProvider = ({zoom = 15, center, googleMapsApiKey, children}: ProviderProps) => {
  if(!googleMapsApiKey) return <></>
  
  const [mapInstance, setMapInstance] = useState<google.maps.Map>()
  const [centerAux, setCenterAux] = useState<google.maps.LatLngLiteral | google.maps.LatLng>(center)
  const [layer, setLayer] = useState<LayerProp>(MAP_ROAD)
  
  const [trafficLayer, setTrafficLayer] = useState<google.maps.TrafficLayer>()
  const [transitLayer, setTransitLayer] = useState<google.maps.TransitLayer>()
 
  const { isLoaded, loadError } = useJsApiLoader({googleMapsApiKey,libraries: ['places', 'geometry']})

  const onLoad = useCallback(map => {    
    setMapInstance(map)
  }, [])

  const fillCenter = () => {
    if (navigator?.geolocation && centerAux === undefined) {        
        navigator.geolocation.getCurrentPosition(position => {
            setCenterAux({ lat: position.coords.latitude, lng: position.coords.longitude })
        })
    }
  }

  useEffect(() => {
    if(mapInstance){
      setTrafficLayer(new google.maps.TrafficLayer({ autoRefresh: true}))
      setTransitLayer(new google.maps.TransitLayer())

      fillCenter()
    }
  }, [mapInstance])

  return <GoogleMapsContext.Provider value={{mapInstance, trafficLayer, transitLayer, layer, setLayer}}>
    {
      isLoaded ? <Map onLoad={onLoad} zoom={zoom} center={centerAux} children={children} />: <div className='loading'/>
    }
    
  </GoogleMapsContext.Provider>
}

export default GoogleMapsProvider

